module.exports = __webpack_public_path__ + "static/media/orders_color.3e1261f6.svg";